import ServiceModule from "./ServiceModule";
var service_module_default = ServiceModule;
export {
  service_module_default as default
};
